<div
  [ngClass]="full ? 'container--full' : ''"
  class="container"
>
  <ng-content></ng-content>
</div>
